// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"PlaylistInfoCard_thumbnail__c5c5K","playlist-name":"PlaylistInfoCard_playlist-name__bTfIq","total":"PlaylistInfoCard_total__46l0H"};